let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jCSF0")).then(() => parcelRequire('k0A2C'));